import { ActionReducer, createFeature, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import { IAgent, IAgentsResponse } from '../../shared/models/agents.model';
import { ApiState } from '../../shared/models/api-state.model';
import { AGENTS_API_ACTIONS } from '../actions';
import { IConversationDetails } from '../../shared/models/conversation-details.model';

export const AGENTS_STATE_KEY = 'agents';

export interface IAgentsState extends ApiState<IAgentsResponse> {}

export const initialState: IAgentsState = new ApiState<IAgentsResponse>();

const reducer: ActionReducer<IAgentsState> = createReducer<IAgentsState>(
  initialState,
  on(AGENTS_API_ACTIONS.get, (state): IAgentsState => state.load()),
  on(AGENTS_API_ACTIONS.error, (state, { error }): IAgentsState => state.setError(error)),
  on(AGENTS_API_ACTIONS.getSuccess, (state, data): IAgentsState => state.success(data)),
  on(AGENTS_API_ACTIONS.update, (state): IAgentsState => state.update(state.data as IAgentsResponse)),
  on(AGENTS_API_ACTIONS.updateSuccess, (state) => state.success(state.data as IAgentsResponse)),
);

export const AGENTS_REDUCER = createFeature({
  name: AGENTS_STATE_KEY,
  reducer,
  extraSelectors: ({ selectAgentsState }) => ({
    getAgentByName: (conversationDetails: IConversationDetails | null): MemoizedSelector<any, IAgent | null> =>
      createSelector(selectAgentsState, ({ data }: IAgentsState): IAgent | null => {
        if (!data || !conversationDetails) return null;

        return (
          (Object.values(data) as IAgent[][])
            .reduce((acc, currentValue) => acc.concat(currentValue), [])
            .find(
              (agent) =>
                agent.firstName === conversationDetails.agentFirstName &&
                agent.lastName === conversationDetails.agentLastName,
            ) || null
        );
      }),
  }),
});
